/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Status_FinishedInputs */



/**
* | output |
* | --- |
* | "Finished" |
*
* @param {League_Status_FinishedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_status_finished = /** @type {((inputs?: League_Status_FinishedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Status_FinishedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalizada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Encerrada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Terminato")
	return /** @type {LocalizedString} */ ("Finished")
});